import { styled } from 'styled-components';

import { placeholder } from 'app/style/mixins';

export const StyledCirclePlaceholder = styled.div`
    ${placeholder};
    border-radius: 100%;
`;
